import React from "react";
import PropTypes from "prop-types";
import {
  ReactRequiredChildren,
  ReactComponentStaticProps,
} from "../../types/react";

import styles from "./ComparisonTable.scss";

export type ComparisonTableRowHeaderSublineProps = ReactRequiredChildren<
  React.ComponentPropsWithoutRef<"div">
>;

export const ComparisonTableRowHeaderSubline: ((
  props: ComparisonTableRowHeaderSublineProps
) => JSX.Element) &
  ReactComponentStaticProps<ComparisonTableRowHeaderSublineProps> = ({
  children,
  ...restProps
}) => {
  return (
    // Block elements break sticky column behaviour, therefore used span with br
    <>
      <br />
      <span className={styles["row-header-subline"]} {...restProps}>
        {children}
      </span>
    </>
  );
};

ComparisonTableRowHeaderSubline.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

ComparisonTableRowHeaderSubline.displayName =
  "ComparisonTable.RowHeaderSubline";

export default ComparisonTableRowHeaderSubline;
